<template>
    <div class="panel panel-default m-t-md">
        <div class="panel-heading">Subtitle Correction</div>
        <div class="panel-body">
            <div style="padding: 30px; margin-bottom: 50px; width: 100%" class="pull-left">
                <div style="color:darkred;" id="audioAffectedLabel" class="pull-left row">
                    <div class="col-md-6">
                        <input required type="radio" name="affects_translations" id="affects_translations_yes"
                               value="yes"/>
                        <label for="affects_translations_yes">Corrections Affect Translations</label><br>
                        The modifications to the subtitle include changes that need to be translated into other
                        languages, such as different wording, sentences, fact mistakes, etc. This will result in all
                        languages needing translation corrections, which in turn results in re-dubbing all languages,
                        which is expensive! Only select this if you are certain that this <b>MUST</b> be done. This is
                        not an option for a "nice-to-have" change!
                    </div>
                    <div class="col-md-6">
                        <input required type="radio" name="affects_translations" id="affects_translations_no"
                               value="no"/>
                        <label for="affects_translations_no">Corrections Don't Affect Translations</label><br>
                        The modifications to the subtitle do not include changes that need to be translated again. This
                        is for fixing typos, switching words for synonyms, punctuation and grammar mistakes. Choosing
                        this option will cause the English script to be fixed for other countries and in some cases also
                        the English voice for other countries.
                    </div>
                </div>
            </div>
            <subtitle-correction-cue
                    v-for="(cue, number) in masterCues"
                    :number="number"
                    :timestamp="timestampsArray[number]"
                    :lines="cue"
                    :key="number">
            </subtitle-correction-cue>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'lessonCode': String,
            'masterCuesJson': String,
            'timestamps': String
        },

        data: function() {
            return {
                masterCues: JSON.parse(this.masterCuesJson),
                timestampsArray: JSON.parse(this.timestamps),
            };
        },

        mounted() {
            $('[data-toggle="tooltip"]').tooltip();
        },
    };
</script>
